import { Button, CircularProgress } from "@mui/joy";
import { SxProps } from "@mui/material";
import { MouseEventHandler } from "react";

interface WrappedButtonProps {
	busy?: boolean;
	sx?: SxProps | undefined;
	onClick: MouseEventHandler<HTMLAnchorElement>;
	children: any;
}
export default function WrappedButton(props: WrappedButtonProps) {
	return (
		<Button onClick={props.onClick} disabled={props.busy}>
			{props.busy && <CircularProgress sx={{ mr: 1 }} />}
			{props.children}
		</Button>
	);
}
